export function getDescription(separator) {
  try {
    let description = "";
    if (Array.isArray(separator) && separator.length === 2) {
      description = separator[1];
    }
    if (Array.isArray(separator) && separator.length > 2) {
      description = separator.slice(1).join(":");
    }

    return description;
  } catch (error) {
    return "";
  }
}
